import styled from 'styled-components'

const InfoPanelStyle = styled.div`
  background-color: ${props => props.theme.background};
  padding-bottom: 8px;

  .info {
    background-color: ${props => (props.warningColor ? '#fed16c' : 'white')};
    width: 100%;
    min-height: 56px;
    display: grid;
    grid-template-columns: 56px 1fr auto;
    grid-column-gap: 16px;
    padding-right: 20px;
    align-items: center;
    border-radius: 3px;
    box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);

    font-family: Ubuntu;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 0.3px;
    color: ${props => props.theme.black60};

    .info-icon {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      border-right: 1px solid #426976;
      color: ${props => (props.warningColor ? '#9a7e41' : '#6fb1c7')};
      padding-top: 16px;
    }

    .info-text {
      padding: 8px 0;
      ul {
        margin: 0;
      }
    }

    .info-more {
      font-size: 11px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.82;
      letter-spacing: 0.6px;
      color: var(--black-60);

      height: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 16px;

      span {
        cursor: pointer;
      }
    }

    .icon {
      color: #000;
      opacity: 0.38;
    }
  }
`

export default InfoPanelStyle
